<template>
  <pt-old-to-new-table class="pt-old-to-new-table__withData" :tableLabels="tableLabels" @getTableData="getTableData" :tableData="tableData" :selectTab="selectTab"
  :totalNumber="totalNumber" :pageSize="pageSize" ref="table" @select="select" @selectAll="selectAll" :isOutside="isOutside" v-loading="loading">
      <slot/>
  </pt-old-to-new-table>
</template>

<script>
import PtOldToNewTable from './index'
export default {
  name: 'pt-old-to-new-table__withData',
  components: {
    'pt-old-to-new-table': PtOldToNewTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    queryParams: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    },
    selectTab: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      pageSize: 10,
      isOutside: false,
      loading: false
    }
  },
  watch: {
    queryParams: {
      handler: function (val) {
        if (!this.isFromRouter) {
          this.$refs.table.resetPage()
        } else {
          this.isOutside = true
          this.getTableData(this.page)
        }
      },
      deep: true
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  methods: {
    select (row) {
      this.$emit('select', row)
    },
    selectAll (rows) {
      this.$emit('selectAll', rows)
    },
    getTableData (page, next) {
      let data = {
        ...this.queryParams,
        pageable: {
          page: this.page,
          size: this.pageSize,
          sort: 'achieveDate,desc'
        }
      }
      this.loading = true
      this.$store.dispatch('customerBringNew', data).then(res => {
        if (next) {
          next(res.data)
        }
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.$refs.table.showReTry()
        this.$message.error(err || '获取脐荐康列表失败')
      })
    }
  }
}
</script>
